import l from "./highrise191.mjs";
import { resolveComponent as n, createBlock as r, openBlock as i, normalizeClass as o, normalizeStyle as a, withCtx as s, renderSlot as d } from "vue";
/* empty css             */
import m from "./highrise181.mjs";
function p(e, h, c, v, f, y) {
  const t = n("NDivider");
  return e.slots.default ? (i(), r(t, {
    key: 0,
    id: e.id,
    "title-placement": e.titlePlacement,
    dashed: e.dashed,
    vertical: e.vertical,
    style: a(e.themeStyles),
    class: o(["hr-divider__container", e.marginTop ? "" : "hr-no-margin-top", e.marginBottom ? "" : "hr-no-margin-bottom"])
  }, {
    default: s(() => [
      d(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["id", "title-placement", "dashed", "vertical", "style", "class"])) : (i(), r(t, {
    key: 1,
    id: e.id,
    "title-placement": e.titlePlacement,
    dashed: e.dashed,
    vertical: e.vertical,
    style: a(e.themeStyles),
    class: o(["hr-divider__container", e.marginTop ? "" : "hr-no-margin-top", e.marginBottom ? "" : "hr-no-margin-bottom"])
  }, null, 8, ["id", "title-placement", "dashed", "vertical", "style", "class"]));
}
const B = /* @__PURE__ */ m(l, [["render", p]]);
export {
  B as default
};
